import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import {
  useNotify,
  FormTab,
  SaveButton,
  TabbedForm,
  Toolbar,
  TopToolbar,
  Create,
} from "react-admin";

import {
  ServiceStatus,
  UnitOptions,
  ResourceType,
} from "../../../utils/constants";
import { deepRedirect, getBackPath } from "../../../utils/utils";

import { logError, logHistory } from "../../../utils/appUtils";
import { BackButton } from "../../../components/common/BackButton";
import { ForceTitle } from "../../../components/common/ForceTitle";
import { HelpButton } from "../../../components/common/HelpButton";
import { ServiceHelp } from "./ServiceHelp";
import { ServiceSetupTab } from "./ServiceEdit";

const ServiceCreateToolbar = ({
  basePath,
  backPath,
  account,
  reloadYard,
  ...props
}) => {
  const history = useHistory();
  const notify = useNotify();
  const [isSaving, setIsSaving] = useState(false);

  const transform = (data) => {
    data = { ...data };
    setIsSaving(true);

    data.active = "true";
    data.groups = account ? account.groups : reloadYard.groups;
    data.status = ServiceStatus.AVAILABLE;
    data.reloadYardId = account ? account.reloadYardId : reloadYard.id;
    data.accountId = account ? account.id : reloadYard.id; // sentinel value for template yard services
    data.accountName = account ? account.businessName : "";

    UnitOptions.forEach((unit) => {
      data[unit.column] = data[unit.column] ? parseFloat(data[unit.column]) : 0;
    });

    return data;
  };

  const onSuccess = ({ data }) => {
    const historyNote = {
      parentId: data.id,
      parentType: ResourceType.SERVICE,
      text: "Service created.",
    };
    logHistory(historyNote);

    notify("Service created successfully.", "success");
    deepRedirect(history, backPath);
    setIsSaving(false);
  };

  const onFailure = (error) => {
    setIsSaving(false);
    logError("services:ServiceCreate:onFailure:Service Update", error, notify);
  };

  return (
    <Toolbar style={{ justifyContent: "space-between" }} {...props}>
      <SaveButton
        label="Save"
        saving={isSaving}
        transform={transform}
        onSuccess={onSuccess}
        onFailure={onFailure}
      />
    </Toolbar>
  );
};

const ServiceCreateActions = ({ basePath, backPath, ...props }) => (
  <TopToolbar>
    <HelpButton>
      <ServiceHelp {...props} />
    </HelpButton>
    <BackButton basePath={"/accounts"} backPath={backPath} />
  </TopToolbar>
);

export const ServiceCreate = (props) => {
  const backPath = getBackPath(props);
  const account = props.location?.state?.account;
  const reloadYard =
    props.location?.state?.reloadyard || window.appUser?.reloadYard;
  const taxRateChoices = reloadYard?.taxRates ? reloadYard.taxRates : [{}];
  const initialValues =
    taxRateChoices.length === 1 ? { taxRate: taxRateChoices[0] } : {};

  return (
    <Create
      {...props}
      title={<ForceTitle title="New Service" />}
      mutationMode="pessimistic"
      actions={<ServiceCreateActions backPath={backPath} />}
    >
      <TabbedForm
        variant="outlined"
        submitOnEnter={false}
        initialValues={initialValues}
        toolbar={
          <ServiceCreateToolbar
            {...props}
            backPath={backPath}
            account={account}
            reloadYard={reloadYard}
          />
        }
      >
        <FormTab label="Service Setup">
          <ServiceSetupTab {...props} taxRateChoices={taxRateChoices} />
        </FormTab>
      </TabbedForm>
    </Create>
  );
};
